<template>
    <div class="ado" style="background-color: #fff; margin: 20px;">
        <el-form ref="set-role-form" :model="form" :rules="rules" label-width="120px" size="small">

            <el-form-item label="提交截止时间:" prop="name">
                <el-date-picker v-model="form.name" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
                <!-- <DatePicker type="datetime" placeholder="Select date and time" style="width: 200px"></DatePicker> -->
            </el-form-item>

            <el-form-item label=" ">
                <el-checkbox v-model="isSubmitDeadlineToo">截至后继续提交</el-checkbox>
                <el-checkbox v-model="isRequired">必填</el-checkbox>
            </el-form-item>
            <el-form-item label="填写说明:" prop="topContent">
                <editor ref="topContent" :width="900" :value="form.topContent" @input="inputChange" />
            </el-form-item>
            <el-form-item label="联系说明:" prop="finishContent">
                <editor ref="finishContent" :width="900" :value="form.finishContent" @input="inputChange2" />
            </el-form-item>
            <el-form-item>
                <!-- <el-button type="primary" @click="submit">确定</el-button> -->
                
            </el-form-item>
        </el-form>
        <div class="butCenter">
            <el-button type="primary" class="but" @click="submit()">保存</el-button>
        </div>
    </div>
</template>
  
<script>
import { mapActions } from "vuex";
import editor from '@components/mWangeditor/index.vue'
export default {
    name: 'add-question-other',
    // props: {
    //     info: {
    //         type: Object,
    //         default: function () {
    //             return null;
    //         },
    //     },
    // },
    components: {
        editor,
    },
    // watch: {
    //     'form.banner' (val, old) {
    //         this.validateSingle('set-role-form', 'banner');
    //     },
    //     info (val) {
    //         if (val) {
    //             console.log('mounted', val);
    //             this.form.name = val.name;
    //             this.form.formDefinitionName = val.formDefinitionName;
    //             this.form.banner = val.banner;
    //             this.form.topContent = val.topContent;
    //             this.form.finishContent = val.finishContent;
    //             this.$refs.topContent.setInitData(val.topContent);
    //             this.$refs.finishContent.setInitData(val.finishContent);
    //         }
    //     }
    // },
    data () {
        return {
            // timer: new Date().getTime(),
            value1: '',
            isSubmitDeadlineToo: false,
            isRequired: false,
            form: {
                name: '',
                // formDefinitionName: 'exhibitor',
                // banner: [],
                topContent: '',
                finishContent: '',
            },
            rules: {
                name: [
                    { required: true, message: '请选择提交截止时间', trigger: 'change' }
                ],
                // banner: [
                //     { required: true, type: 'array', message: '请上传图片', trigger: 'change' }
                // ],
                // topContent: [
                //     { required: true, message: '请填写顶部提示', trigger: ['change', 'blur'] }
                // ],
                // finishContent: [
                //     { required: true, message: '请填写完成提示', trigger: ['change', 'blur'] }
                // ],
            },
        };
    },
    mounted () {
        this.init()
    },
    methods: {
        ...mapActions({
            setManageUpdate: 'hostSetModule/setManageUpdate', // 
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //
            exhibition: "hostSetModule/getHostExhibition"
        }),
        resetForm (name) {
            this.$refs[name].resetFields();
            this.form = {
                formDefinitionName: '',
                banner: [],
                topContent: '',
                finishContent: '',
            };
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid)
                })
            })
        },
        inputChange (e) {
            console.log(e);
            this.form.topContent = e;
            if (e) {
                this.validateSingle('set-role-form', 'topContent');
            }
        },
        inputChange2 (e) {
            this.form.finishContent = e;
            if (e) {
                this.validateSingle('set-role-form', 'finishContent');
            }
        },
        async submit () {
            const valid = await this.validForm('set-role-form');
            if (!valid) {
                this.$message.error('表单验证失败！')
                return { valid: false, info: this.form }
            }
            this.onSubmit()
            return { valid: true, info: this.form };
        },
        // 验证单个表单
        validateSingle (form, single) {
            this.$refs[form].validateField(single)
        },
        // 获取
        async init () {
            let opt = {
                providerName: "Global",
                // providerKey: this.exhibition.id,
                names: ['StandardBoothConstructionChange.SubmitDeadline', 'StandardBoothConstructionChange.IsSubmitDeadlineToo', 'StandardBoothConstructionChange.IsRequired', 'StandardBoothConstructionChange.FormDescription', 'StandardBoothConstructionChange.ContractDescription']
            }
            let res = await this.setManageSettingQ(opt)
            if (res) {
                if (res[0].value) {
                    this.form.name = res[0].value
                    this.isSubmitDeadlineToo = res[1].value == 'true' ? true : false
                    this.isRequired = res[2].value == 'true' ? true : false
                    this.$refs.topContent.setInitData(res[3].value);
                    this.$refs.finishContent.setInitData(res[4].value);
                }
            } else {
                this.$message.success('失败')
            }
        },
        async onSubmit () {
            let opt = {
                providerName: "Global",
                providerKey: "",
                values: [
                    { name: "StandardBoothConstructionChange.SubmitDeadline", value: this.form.name ? this.form.name : null },
                    { name: "StandardBoothConstructionChange.IsSubmitDeadlineToo", value: this.isSubmitDeadlineToo ? 'true' : 'false' },
                    { name: "StandardBoothConstructionChange.IsRequired", value: this.isRequired ? 'true' : 'false' },
                    { name: "StandardBoothConstructionChange.FormDescription", value: this.form.topContent ? this.form.topContent : null },
                    { name: "StandardBoothConstructionChange.ContractDescription", value: this.form.finishContent ? this.form.finishContent : null },
                ]
            }
            let res = await this.setManageUpdate(opt)
            if (res) {
                this.$message.success('提交成功')
                this.init()
            } else {
                this.$message.success('提交失败')
            }
        },


    },
}

</script>
  
<style lang="scss" scoped>
.ado {
    padding: 40px 49px;
}
</style>
  